import { forwardRef } from 'react';
import { Tooltip as AntdTooltip } from 'antd';

/**
 * @param {Object} props - Same shape as antd's own `Tooltip`.
 * @param {string} [props.placement='bottom'] - Where the tooltip renders relative to its trigger.
 * @param {number} [props.mouseEnterDelay=0.3] - Seconds of hover before the tooltip appears.
 * @param {number} [props.mouseLeaveDelay=0.2] - Seconds after the pointer leaves before it closes.
 */
const Tooltip = forwardRef(({ placement = 'bottom', mouseEnterDelay = 0.3, mouseLeaveDelay = 0.2, ...props }, ref) => (
    <AntdTooltip ref={ref} placement={placement} mouseEnterDelay={mouseEnterDelay} mouseLeaveDelay={mouseLeaveDelay} {...props} />
));
Tooltip.displayName = 'Tooltip';

export default Tooltip;
